<template>

    <div class="app">
        <component v-if="$auth.ready()" :is="layout" v-show="!$route.params.loginToken">
            <router-view></router-view>
        </component>
        <the-alerts></the-alerts>
    </div>

</template>


<script>

import LayoutPublic from 'Layouts/LayoutPublic'
import LayoutDashboard from 'Layouts/LayoutDashboard'
import TheAlerts from 'Components/Alerts/TheAlerts'

const default_layout = 'dashboard'

export default {

    name: 'App',

    computed: {
        layout() {
            return (this.$route.meta.layout || default_layout) + '-layout'
        }
    },

    components: {
        'dashboard-layout': LayoutDashboard,
        'public-layout': LayoutPublic,
        TheAlerts
    }

}

</script>

<style lang="scss">

.app {
    width: 100%;
    height: 100%;
}

</style>
